export default "__VITE_ASSET__CbhY3rJv__"